import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

function GrupoProdutosPdf(grupos) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    // Cabeçalhos da tabela
    const tableHeader = [
        { text: 'Código do Grupo', style: 'tableHeader' },
        { text: 'Descrição', style: 'tableHeader' },
        { text: 'Mobile', style: 'tableHeader' }
    ];

    // Linhas da tabela com os dados dos grupos
    const tableBody = grupos.map(grupo => [
        { text: grupo.COD_GRUPO, style: 'tableData' },
        { text: grupo.DESCRICAO, style: 'tableData' },
        { text: grupo.CARGA === '1' ? 'Sim' : 'Não', style: 'tableData' }
    ]);

    const docDefinition = {
        content: [
            { text: 'Relatório de Grupos de Produtos', style: 'header', margin: [0, 0, 0, 20] },

            {
                table: {
                    headerRows: 1,
                    widths: ['auto', '*', 'auto'],
                    body: [tableHeader, ...tableBody]
                },
                layout: {
                    fillColor: (rowIndex) => (rowIndex === 0 ? '#eeeeee' : rowIndex % 2 === 0 ? '#f9f9f9' : null),
                    hLineWidth: () => 0.5,
                    vLineWidth: () => 0.5,
                    hLineColor: () => '#cccccc',
                    vLineColor: () => '#cccccc',
                }
            }
        ],
        styles: {
            header: {
                fontSize: 16,
                bold: true,
                alignment: 'center'
            },
            tableHeader: {
                bold: true,
                fontSize: 12,
                color: '#333'
            },
            tableData: {
                fontSize: 11,
                color: '#444'
            }
        },
        pageSize: 'A4',
        pageMargins: [40, 60, 40, 60]
    };

    pdfMake.createPdf(docDefinition).open(); 
}

export default GrupoProdutosPdf;
